import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { TextField } from "@mui/material";
import { BACKSPACE_KEY_CODE, ENTER_KEY_CODE, isNumeric } from "../formatter/utility";
import { useTranslation } from "react-i18next";
export var CvvComponent = function (_a) {
    var _b;
    var formik = _a.formik, cardType = _a.cardType, _c = _a.name, name = _c === void 0 ? "cvc" : _c, _d = _a.label, label = _d === void 0 ? "CVC/CVV" : _d;
    var cvvInput = React.useRef(null);
    var _e = useTranslation(), t = _e.t, i18n = _e.i18n;
    var handleChangeExpiryDate = function (event) {
        if (cvvInput.current) {
            cvvInput.current.value = event.target.value;
            formik.handleChange && formik.handleChange(event);
        }
    };
    var handleKeyPressCVC = function (event) {
        var _a;
        if ((event.ctrlKey && (event.keyCode == 67 || event.keyCode == 65 || event.keyCode == 86 || event.keyCode == 88)) || event.keyCode == 46) {
            return;
        }
        var cvc = ((_a = cvvInput.current) === null || _a === void 0 ? void 0 : _a.value) || '';
        if (event.key !== ENTER_KEY_CODE && event.key !== BACKSPACE_KEY_CODE) {
            if (!isNumeric(event)) {
                event.preventDefault();
            } //087
            if (cardType && cvc.length >= cardType.code.length) {
                event.preventDefault();
            }
            if (cvc.length >= 4) {
                event.preventDefault();
            }
        }
    };
    return (_jsx(TextField, { InputLabelProps: { shrink: true }, ref: cvvInput, label: label, fullWidth: true, name: name, size: "small", onChange: function (e) { handleChangeExpiryDate(e); }, onKeyDown: function (e) { handleKeyPressCVC(e); }, error: formik.touched[name] && Boolean(formik.errors[name]), helperText: t(formik.touched[name] && formik.errors[name]), value: (_b = formik.values[name]) !== null && _b !== void 0 ? _b : '', required: true }));
};
